var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0675 94.7016C82.8724 94.7016 94.8742 82.7375 94.8742 67.9791C94.8742 53.2206 82.8724 41.2565 68.0675 41.2565C53.2625 41.2565 41.2607 53.2206 41.2607 67.9791C41.2607 82.7375 53.2625 94.7016 68.0675 94.7016Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.143 116.901C115.042 118.995 111.597 118.995 109.496 116.901L83.1934 90.6806L90.8404 83.0576L117.227 109.361C119.244 111.372 119.244 114.806 117.143 116.901Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8996 84.6492C77.321 84.6492 84.9585 77.0357 84.9585 67.644C84.9585 58.2523 77.321 50.6387 67.8996 50.6387C58.4783 50.6387 50.8408 58.2523 50.8408 67.644C50.8408 77.0357 58.4783 84.6492 67.8996 84.6492Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9834 104.921L105.21 97.2984L116.975 108.775C119.496 111.372 118.992 114.974 116.975 117.068C114.958 119.246 111.513 119.246 109.412 117.236L97.9834 104.921Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857 109.194L109.16 102.911",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.151 113.382L113.361 108.105",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(40 40)"
  })))));
};
export { SvgMagnifyingGlass as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifying-glass.3e2171b5.svg";